import React from 'react';

import classNames from 'classnames'

import styles from './index.module.scss'

const Spinner = ({className}) => <div className={classNames(styles['spinner'], className)}/>;

export default Spinner;
